/**
 * Client-Side Security Protection
 * Disables developer tools shortcuts and right-click context menu.
 * Safe: does NOT block localStorage/sessionStorage (required for auth).
 */

// ── Keyboard shortcuts ────────────────────────────────────────────────────────
document.addEventListener('keydown', (e: KeyboardEvent) => {
  // F12
  if (e.key === 'F12' || e.keyCode === 123) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // Ctrl+I  (open dev tools shortcut on some browsers)
  if (e.ctrlKey && !e.shiftKey && (e.key === 'i' || e.key === 'I' || e.keyCode === 73)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // Ctrl+Shift+I  (Inspector)
  if (e.ctrlKey && e.shiftKey && (e.key === 'i' || e.key === 'I' || e.keyCode === 73)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // Ctrl+Shift+J  (Console)
  if (e.ctrlKey && e.shiftKey && (e.key === 'j' || e.key === 'J' || e.keyCode === 74)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // Ctrl+Shift+C  (Element picker)
  if (e.ctrlKey && e.shiftKey && (e.key === 'c' || e.key === 'C' || e.keyCode === 67)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }

  // Ctrl+U  (View Source)
  if (e.ctrlKey && !e.shiftKey && (e.key === 'u' || e.key === 'U' || e.keyCode === 85)) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}, true); // capture phase so it intercepts before browser default

// ── Right-click context menu ──────────────────────────────────────────────────
document.addEventListener('contextmenu', (e: MouseEvent) => {
  e.preventDefault();
  return false;
});

export {};
